// extracted by mini-css-extract-plugin
module.exports = {"footer":"MenuFooter_footer__v69ES","footerSection":"MenuFooter_footerSection__s2_3S","footerImage":"MenuFooter_footerImage__IDr7c"};